module.exports = __webpack_public_path__ + "img/PlayCircle-blue.328f45bc.svg";